import React from 'react';

import { SqueezeDivider, Subsection, SubsectionProps } from './components';
import {
  HeaderCell,
  HeaderContainer,
  InnerContainer,
  MainContainer,
} from './SqueezeRedesignProducts.style';
import { useProductsContent } from './useProductsContent';
import colors from 'styles/constants/colors';

export interface SqueezeRedesignProductsProps {
  headerCells?: Array<string>;
  products?: Array<SubsectionProps>;
  hideSqueeze?: boolean;
  backgroundColor?: string;
  showChia?: boolean;
}

const moduleName = 'products';

export const SqueezeRedesignProducts = ({
  headerCells = [],
  products = [],
  hideSqueeze = false,
  backgroundColor = colors.surfaceLight,
  showChia = false,
}: SqueezeRedesignProductsProps) => {
  const productsContent =
    products.length === 0 ? useProductsContent(showChia) : products;

  return (
    <MainContainer data-module={moduleName} backgroundColor={backgroundColor}>
      <InnerContainer>
        <HeaderContainer>
          {headerCells.map((headerCell) => (
            <HeaderCell key={headerCell}>{headerCell}</HeaderCell>
          ))}
        </HeaderContainer>
        {productsContent.map((subsectionContent) => (
          <Subsection
            key={subsectionContent.moduleName}
            content={subsectionContent}
          />
        ))}
      </InnerContainer>
      {!hideSqueeze && <SqueezeDivider />}
    </MainContainer>
  );
};
